import * as swcHelpers from '@swc/helpers';

const objectToFormState = (data)=>{
    return Object.entries(data).reduce((acc, [formKey, pairs])=>{
        if (!pairs) {
            return {};
        }
        const newFormState = Object.entries(pairs).reduce((formValueState, [key, value])=>{
            return typeof value !== 'undefined' ? swcHelpers.objectSpread({}, formValueState, {
                [key]: {
                    name: key,
                    value,
                    isTouched: false
                }
            }) : formValueState;
        }, {});
        return swcHelpers.objectSpread({}, acc, {
            [formKey]: swcHelpers.objectSpread({}, acc[formKey], {
                formName: formKey,
                formValid: false,
                formState: swcHelpers.objectSpread({}, (acc[formKey] || {}).formState, newFormState)
            })
        });
    }, {});
};
const fieldsToFormState = (data, defaults)=>Object.entries(data).reduce((result, [name, value])=>swcHelpers.objectSpread({}, result, {
            [name]: swcHelpers.objectSpread({
                name,
                value: String(value),
                isTouched: false
            }, defaults)
        })
    , {})
;

export { fieldsToFormState, objectToFormState };
//# sourceMappingURL=object-to-form-state.js.map
